import FlightSearch from "../screens/flight/FlightSearch";
import CorporateManagement from "../screens/controlPanel/CorporateManagement";
import Changepassword from "../screens/Changepassword";
import UpdateTopupRequest from "../screens/fund/Credit/UpdateTopupRequest";
import HotelBooking from "../screens/Hotels/HotelBooking";
import HotelBookingHistory from "../screens/Hotels/HotelBookingHistory";
import AssignCommission from "../screens/businessEntry/AssignCommission";
import VoucherCode from "../screens/businessEntry/VoucherCode";
import CorporateList from "../screens/controlPanel/CorporateList";
import TopUpRequest from "../screens/fund/Credit/TopUpRequest";
import FlightBookingHistory from "../screens/flight/FlightBookingHistory";
import AdminUserManagement from "../screens/controlPanel/AdminUserManagement";
import UserInfoList from "../screens/controlPanel/UserInfoList";
import UserManagement from "../screens/controlPanel/UserManagement";
import PaymentCard from "../screens/businessEntry/PaymentCard";

export const MENU_CONFIG = [
  {
    label: "Home",
    code: "home",
    children: [
      {
        label: "Dashboard",
        path: "/dashboard",
        code: "dashboard",
      },
    ],
  },
  {
    label: "Flight",
    icon: "fa-solid fa-plane-departure me-2",
    code: "flight",
    children: [
      // {
      //   label: "Ancillary Services",
      //   path: "/ancillaryservices",
      //   code: "flight_ancillary",
      //   element: <AncillaryServices />,
      // },
      {
        label: "Book Flight",
        path: "/flightbooking",
        code: "flight_booking",
        element: <FlightSearch />,
      },
      // {
      //   label: "Manage Booking",
      //   path: "/managebooking",
      //   code: "flight_manage",
      //   element: <ManageBooking />,
      // },
      {
        label: "Booking History",
        path: "/flightbookinghistory",
        code: "flight_booking_history",
        element: <FlightBookingHistory />,
      },
    ],
  },

  {
    label: "Hotel",
    icon: "✈️",
    code: "hotel",
    children: [
      {
        label: "Book a Hotel",
        path: "/hotelbooking",
        code: "hotel_booking",
        element: <HotelBooking />,
      },
      {
        label: "Manage Booking",
        path: "/managehotelbooking",
        code: "hotel_manage",
        element: <HotelBookingHistory />,
      },
    ],
  },
  {
    label: "Business Entry",
    code: "business_entry",
    children: [
      // {
      //   label: "Airline Baggage",
      //   path: "/airlineBaggage",
      //   code: "business_airline_baggage",
      //   element: <AirlineBaggage />,
      // },
      // {
      //   label: "Airline Mapping",
      //   path: "/airlinemapping",
      //   code: "business_airline_mapping",
      //   element: <AirlineMapping />,
      // },
      {
        label: "Assign/Discount Earning",
        code: "business_commission",
        children: [
          // {
          //   label: "Hotel Commission",
          //   path: "/hotelcommission",
          //   code: "hotel_commission",
          //   element: <HotelCommission />,
          // },
          {
            label: "Flight Commission",
            path: "/assigncommission",
            code: "flight_commission",
            element: <AssignCommission />,
          },
        ],
      },
      // {
      //   label: "Code Config",
      //   path: "/codeconfig",
      //   code: "business_code_config",
      //   element: <CodeConfig />,
      // },

      // {
      //   label: "FOP (Form of Payment)",
      //   path: "/fop",
      //   code: "business_fop",
      //   element: <Fop />,
      // },
      // {
      //   label: "Inventory",
      //   code: "business_inventory",
      //   children: [
      //     {
      //       label: "Flight Schedule",
      //       path: "/flightschedule",
      //       code: "flightschedule",
      //     },
      //     {
      //       label: "Fare View",
      //       path: "/fareview",
      //       code: "fareview",
      //     },
      //     {
      //       label: "Stock Report",
      //       path: "/stockreport",
      //       code: "stockreport",
      //     },
      //     {
      //       label: "Sales Report",
      //       path: "/salesreport",
      //       code: "salesreport",
      //     },
      //     {
      //       label: "Offline Ticket Accounting",
      //       path: "/offlineticketaccounting",
      //       code: "offlineticketaccounting",
      //     },
      //     {
      //       label: "Offline Inventory Summary",
      //       path: "/offlineinventorysummary",
      //       code: "offlineinventorysummary",
      //     },
      //   ],
      // },
      // {
      //   label: "PG Charges",
      //   path: "/pgcharges",
      //   code: "business_fop",
      //   element: <PGCharges />,
      // },
      {
        label: "Voucher Code",
        path: "/vouchercsode",
        code: "vouchercode",
        element: <VoucherCode />,
      },

      {
        label: "Transactions ",
        path: "/paymentcard",
        code: "vouchercode",
        element: <PaymentCard />,
      },
      // {
      //   label: "Airline Penalty Charges",
      //   path: "/airlinepenaltycharges",
      //   code: "vouchercode",
      //   element: <AirlinePenaltyCharges />,
      // },
      // {
      //   label: "Supplier Commission",
      //   path: "/commissionmarkup",
      //   code: "vouchercode",
      //   element: <ViewSupplierCommission />,
      // },
    ],
  },
  {
    label: "Fund",
    icon: "💰",
    code: "fund",
    children: [
      // {
      //   label: "Credit/Debit Entry",
      //   path: "/creditdebit",
      //   code: "fund_credit_debit",
      //   element: <DebitEntry />,
      // },
      // {
      //   label: "Debit Balance",
      //   path: "/debitbalance",
      //   code: "fund_debit",
      //   element: <DabitBalance />,
      // },
      // {
      //   label: "Credit Control",
      //   path: "/creditControl",
      //   code: "creditControl", //not comes under permission
      //   element: <CreditControl />,
      // },
      // {
      //   label: "Update Customer Balance",
      //   path: "/updateCustomerBalance",
      //   code: "fund_update_balance",
      //   element: <UpdateCustomerBalance />,
      // },
      {
        label: "Update Top-up Request",
        path: "/updatetopuprequest",
        code: "updatetopuprequest", //not comes under permission
        element: <UpdateTopupRequest />,
      },
      {
        label: "Top-up Request",
        path: "/topuprequest",
        code: "create_topup_request",
        element: <TopUpRequest />,
      },
      // {
      //   label: "Vendor Balance",
      //   path: "/vendorbalance",
      //   code: "fund_vendor_balance",
      //   element: <VendorBalance />,
      // },
      // {
      //   label: "Easy Payment",
      //   path: "/easypayment",
      //   code: "easypayment", //not comes under permission
      //   element: <EasyPayment />,
      // },
      // {
      //   label: "Corporate Postpaid Account",
      //   path: "/corporatepostpaidaccount",
      //   code: "CorporatePostpaidAccount", //not comes under permission
      //   element: <CorporatePostpaidAccount />,
      // },
    ],
  },
  {
    label: "Control Panel",
    code: "control_panel",
    children: [
      {
        label: "Admin User Management",
        path: "/adminusermanagement",
        code: "Admin_User_Management",
        element: <AdminUserManagement />,
      },
      {
        label: "Corporate Management",
        code: "Corporate Management",
        children: [
          {
            label: "Create Corporate",
            path: "/corporatemanagement",
            code: "corporate_management", // maps to corporate_b2b
            element: <CorporateManagement />,
          },
          {
            label: "Corporate List",
            path: "/corporatelist",
            code: "",
            element: <CorporateList />,
          },
          {
            label: " Create Corporate User",
            path: "/usermanagement",
            code: "user_management",
            element: <UserManagement />,
          },
          {
            label: "Corporate User List",
            path: "/userinfolist",
            code: "user_info_list",
            element: <UserInfoList />,
          },
        ],
      },

      // {
      //   label: "ROE Updation",
      //   path: "/roeupdation",
      //   code: "control_roe_update", // maps to control_roe_update
      //   element: <ROEUpdation />,
      // },
      // {
      //   label: "Airline Segment Mapping",
      //   path: "/airlineSegment",
      //   code: "control_airline_segments", // maps to control_airline_segments
      //   element: <AirlineSegments />,
      // },
      // {
      //   label: "Advertisement",
      //   path: "/advertisement",
      //   code: "adcontrol_advertisementvertisement", // maps to control_advertisement
      //   element: <Advertisement />,
      // },
      // {
      //   label: "Notice Board",
      //   path: "/noticeboard",
      //   code: "control_notice_board", // maps to control_notice_board
      //   element: <NoticeBoard />,
      // },

      // {
      //   label: "Corporate (B2E)",
      //   path: "/Corporate (B2E)",
      //   code: "",
      //   element: < />,
      // },
      // {
      //   label: "Supplier Management",
      //   path: "/suppliermanagement",
      //   code: "",
      // },
      // {
      //   label: "Agent (B2B)",
      //   path: "/agentcreation",
      //   code: "",
      //   element: <AgentCreation />,
      // },
      // {
      //   label: "Customer (B2C)",
      //   path: "/customermanagement",
      //   code: "",
      //   element: <CustomerManagement />,
      // },
      // {
      //   label: "Pending Agent Request",
      //   path: "/pendingagentrequest",
      //   code: "",
      //   element: <PendingAgentRequest />,
      // },
      // {
      //   label: "Add GST",
      //   path: "/addgstdetails",
      //   code: "",
      //   element: <AddGSTDetails />,
      // },
      // {
      //   label: "Add Bank Details",
      //   path: "/addbankdetails",
      //   code: "",
      //   element: <AddBankDetails />,
      // },
      // {
      //   label: "Thread Key Mapping",
      //   path: "/threadkeymapping",
      //   code: "",
      //   element: <ThreadKeyMapping />,
      // },
      // {
      //   label: "Ticket Points",
      //   path: "/Ticket",
      //   code: "",
      //   element: <Ticket />,
      // },
      // {
      //   label: "IP/2FA",
      //   path: "/ipconfiguration",
      //   code: "",
      //   element: <IPConfiguration />,
      // },
      // {
      //   label: "Throttle Management",
      //   path: "/throttlemanagement",
      //   code: "",
      //   element: <FlightRating />,
      // },

      {
        label: "Change Password",
        path: "/changepassword",
        code: "control_change_password", // maps to control_change_password
        element: <Changepassword />,
      },
    ],
  },

  // {
  //   label: "Action",
  //   code: "action",
  //   children: [
  //     {
  //       label: "Booking Track",
  //       path: "/bookingtrack",
  //       code: "action_booking_track", // maps to action_booking_track
  //       element: <BookingTrack />,
  //     },
  //     {
  //       label: "Payment Track",
  //       path: "/paymentgatewaytrack",
  //       code: "action_payment_gateway", // maps to action_payment_gateway
  //       element: <PaymentTrack />,
  //     },
  //     {
  //       label: "Retrieve PNR",
  //       path: "/retrievepnr",
  //       code: "action_retrieve_pnr", // maps to action_retrieve_pnr
  //       element: <RetrieveAccounting />,
  //     },
  //     {
  //       label: "Schedule Update",
  //       path: "/scheduleupdate",
  //       code: "action_schedule_update", // maps to action_schedule_update
  //       element: <ScheduleUpdate />,
  //     },
  //     {
  //       label: "SSR Updation",
  //       path: "/ssrupdation",
  //       code: "action_ssr_update", // maps to action_ssr_update
  //       element: <SSRUpdation />,
  //     },
  //     {
  //       label: "Infant Manual Booking",
  //       path: "/infantmanualbooking",
  //       code: "action_manual_booking", // assumed to map to action_manual_booking
  //       element: <InfantManualBooking />,
  //     },
  //     {
  //       label: "Ticket To Cancel",
  //       path: "/cancelticket",
  //       code: "", // maps to action_ssr_update
  //       element: <CancelTicket />,
  //     },
  //     {
  //       label: "Ticket To Reschedule",
  //       path: "/rescheduleticket",
  //       code: "", // maps to action_ssr_update
  //       element: <RescheduleTicket />,
  //     },
  //     {
  //       label: "Fare Rule",
  //       path: "/farerule",
  //       code: "", // maps to action_ssr_update
  //       element: <FareRule />,
  //     },
  //     {
  //       label: "Visa",
  //       path: "/visacreate",
  //       code: "", // maps to action_ssr_update
  //       element: <VisaCreate />,
  //     },
  //     {
  //       label: "Trip Travel Request",
  //       path: "/tripbookingrequest",
  //       code: "", // maps to action_ssr_update
  //       element: <TripBookingRequest />,
  //     },

  //     {
  //       label: "Insurance Plan View",
  //       path: "/insurancePlan",
  //       code: "", // maps to action_ssr_update
  //       element: <InsurancePlan />,
  //     },
  //     {
  //       label: "ERP Status",
  //       path: "/erpstatus",
  //       code: "", // maps to action_ssr_update
  //       element: <ERPStatus />,
  //     },
  //     {
  //       label: "Unpurge PNR",
  //       path: "/unpurgepnr",
  //       code: "", // maps to action_ssr_update
  //       element: <UnpurgePNR />,
  //     },
  //     {
  //       label: "Airline DSR Upload",
  //       path: "/airlinedsrupload",
  //       code: "", // maps to action_ssr_update
  //       element: <AirlineDSRUpload />,
  //     },
  //     {
  //       label: "Passenger Profile",
  //       path: "/passengerprofile",
  //       code: "", // maps to action_ssr_update
  //       element: <PassengerProfile />,
  //     },
  //     {
  //       label: "Push Notification",
  //       path: "/mobilepushnotification",
  //       code: "", // maps to action_ssr_update
  //       element: <MobilePushNotification />,
  //     },
  //     {
  //       label: "Admin Configuration",
  //       path: "/adminconfiguration",
  //       code: "", // maps to action_ssr_update
  //       element: <AdminConfiguration />,
  //     },
  //     {
  //       label: "PNR Transaction History",
  //       path: "/pnrtransactionhistory",
  //       code: "", // maps to action_ssr_update
  //       element: <PNRTransactionHistory />,
  //     },
  //   ],
  // },

  //
  //     {'name': 'Customer Analysis', 'code': 'customerAnalysis'},
  //     {'name': 'My Agencies', 'code': 'myAgencies'},
  //     {'name': 'My Sales', 'code': 'mySales'},
  //     {'name': 'Shadow Balance', 'code': 'shadowBalance'},
  //     {'name': 'Day wise Agent Balance', 'code': 'dayWiseAgentBalance'},
  //     {'name': 'Day Wise Opening Balance', 'code': 'dayWiseOpeningBalance'},
  //     {'name': 'PNR Remarks', 'code': 'pnrRemarks'},
  //     {'name': 'Offline PNR Report', 'code': 'offlinePnrReport'},
  //     {'name': 'Flight Series', 'code': 'flightSeries'},
  //     {'name': 'Credit / Debit Transaction', 'code': 'creditDebitTransaction'},
  //     {'name': 'PNR Transaction History', 'code': 'pnrTransactionHistory'},
  //     {'name': 'Savings Report', 'code': 'savingsReport'},
  //     {'name': 'Customer Deposit Details', 'code': 'customerDepositDetails'},
  //     {'name': 'Policy wise sales', 'code': 'policyWiseSales'},
  //     {'name': 'Oustanding', 'code': 'oustading'},
  //     {'name': 'Agent Invoice Details Report', 'code': 'agentInvoiceDetailsReport'},
  //     {'name': 'Credit Debit Report', 'code': 'creditDebitReport'},
  //     {'name': 'No Show Details', 'code': 'noShowDetails'},
  //     {'name': 'Ticket Reconciliation', 'code': 'ticketReconciliation'},
  //     {'name': 'Credit Info', 'code': 'creditInfo'},
  //     {'name': 'Supplier Commission Details', 'code': 'supplierCommissionDetails'},
  //     {'name': 'L2B Details', 'code': 'l2bDetails'},
  //
  //     {'name': 'Cancel and Reschedule Request Detail', 'code': 'cancelAndRescheduleRequestDetail'},
  //     {'name': 'Distributor Ledger', 'code': 'distributorLedger'},
  //     {'name': 'Agent Details', 'code': 'agentDetails'},
  //     {'name': 'Service Fee/Markup Details', 'code': 'serviceFeeMarkupDetails'},
  //     {'name': 'Commission Details', 'code': 'commissionDetails'},
  //     {'name': 'Invoice Detail', 'code': 'invoiceDetail'},
  //     {'name': 'Fare Trend Details', 'code': 'fareTrendDetails'},
  //     {'name': 'MIS Sales Analysis', 'code': 'misSalesAnalysis'}
  // ]

  // {
  //   label: "Reports",
  //   code: "reports",
  //   children: [
  //     {
  //       label: "Detailed Transaction",
  //       path: "/agenttransaction",
  //       code: "reports_agent_transaction", // maps to reports_agent_transaction
  //       element: <DetailedTransaction />,
  //     },
  //     {
  //       label: "PNR-wise Sales",
  //       path: "/airlinepnrsales",
  //       code: "reports_airline_pnr_sales", // maps to reports_airline_pnr_sales
  //       element: <PNRWiseSales />,
  //     },
  //     {
  //       label: "Consolidated Sales",
  //       path: "/ConsolidateSales",
  //       code: "reports_consolidate_sales", // maps to reports_consolidate_sales
  //       element: <ConsolidateSales />,
  //     },
  //     {
  //       label: "Agent Balance",
  //       path: "/agentbalance",
  //       code: "reports_day_wise_balance", // maps to reports_day_wise_balance
  //       element: <DaywiseAgentBalance />,
  //     },
  //     {
  //       label: "Monthly Ticket Count",
  //       path: "/monthlyticketcount",
  //       code: "reports_monthly_ticket", // maps to reports_monthly_ticket
  //       element: <MonthlyTicketCount />,
  //     },
  //     {
  //       label: "Savings Report",
  //       path: "/savingsreport",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <SavingsReport />,
  //     },
  //     {
  //       label: "Customer Transaction",
  //       path: "/customertransactiondetails",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <CustomerTransactionDetails />,
  //     },
  //     {
  //       label: "Update Customer Balance",
  //       path: "/updatecustomerbalance",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <UpdateCustomerBalance />,
  //     },
  //     {
  //       label: "Cash Payment Details",
  //       path: "/cashpaymentdetails",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <CashPaymentDetails />,
  //     },
  //     {
  //       label: "Daily Ticket Count",
  //       path: "/dailyticketcount",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <DailyTicketCount />,
  //     },
  //     {
  //       label: "Agency List",
  //       path: "/agencylist",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <AgencyList />,
  //     },

  //     {
  //       label: "Sales Summary",
  //       path: "/salessummary",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <SalesSummary />,
  //     },
  //     {
  //       label: "Sales Volume Airline Wise",
  //       path: "/salesvolumeairlinewise",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <SalesVolumeAirlineWise />,
  //     },
  //     {
  //       label: "Topup Report",
  //       path: "/topupreport",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <TopupReport />,
  //     },
  //     {
  //       label: "Staff Wise Sales",
  //       path: "/staffwisesales",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <StaffWiseSales />,
  //     },
  //     {
  //       label: "My Sales",
  //       path: "/staffwisesales",
  //       code: "reports_monthly_ticket", // maps to reports_savings
  //       element: <MySales />,
  //     },
  //   ],
  // },
  // {
  //   label: "Visa",
  //   children: [
  //     {
  //       label: "Create Visa",
  //       path: "/VisaCreate",
  //       code: "VisaCreate",
  //     },
  //     // {
  //     //   label: "Visa History",
  //     //   path: "/visahistory",
  //     //   code: "visahistory",
  //     // },
  //     // {
  //     //   label: "Search Visa",
  //     //   path: "/visasearch",
  //     //   code: "visasearch",
  //     // },
  //     {
  //       label: "Manage Visa Booking",
  //       path: "/visamanagebooking",
  //       code: "visamanagebooking",
  //     },
  //   ],
  // },
];

export const impliedPermissions = {
  home: ["dashboard"],
  flight: ["flight_booking_history"],
  // business_commission: ["hotel_commission", "flight_commission"],
};

export const conditionalCodes = [
  {
    code: "flight_booking_history",
    parent: "flight",
  },
];

// modules_data = {
//     'Flight': [
//         {'name': 'Ancillary Services', 'code': 'flightancillary'},
//         {'name': 'Book a Flight', 'code': 'flightbooking'},
//         {'name': 'Manage Booking', 'code': 'flightmanage'},
//     ],
//     'Hotel': [
//         {'name': 'Book a Hotel', 'code': 'hotelbooking'},
//         {'name': 'Manage Booking', 'code': 'managehotelbooking'},
//     ],
//     'Fund': [
//         {'name': 'Credit/Debit Balance', 'code': 'creditdebit'},
//         {'name': 'Debit Balance', 'code': 'debitbalance'},
//         {'name': 'Update Customer Balance', 'code': 'updateCustomerBalance'},
//          {'name': 'Update Topup Request', 'code': 'updatetopuprequest'},
//         {'name': 'Vendor Balance', 'code': 'vendorbalance'},
//         {'name': 'Easy Payment', 'code': 'easypayment'},
//         {'name': 'Credit Control', 'code': 'creditControl'},
//     ],
//
//     'Reports': [
//     {'name': 'Customer Transaction', 'code': 'customerTransaction'},
//     {'name': 'Update Customer Balance', 'code': 'updateCustomerBalance'},
//     {'name': 'PNR Wise Sales', 'code': 'pnrWiseSales'},
//     {'name': 'Customer Analysis', 'code': 'customerAnalysis'},
//     {'name': 'Cash Payment Details', 'code': 'cashPaymentDetails'},
//     {'name': 'Monthly Ticket Count', 'code': 'monthlyTicketCount'},
//     {'name': 'Daily Ticket Count', 'code': 'dailyTicketCount'},
//     {'name': 'Agency List', 'code': 'agencyList'},
//     {'name': 'My Agencies', 'code': 'myAgencies'},
//     {'name': 'Sales Summary', 'code': 'salesSummary'},
//     {'name': 'Sales Volume Airline Wise', 'code': 'salesVolumeAirlineWise'},
//     {'name': 'Topup Report', 'code': 'topupReport'},
//     {'name': 'Staff Wise Sales', 'code': 'staffWiseSales'},
//     {'name': 'My Sales', 'code': 'mySales'},
//     {'name': 'Shadow Balance', 'code': 'shadowBalance'},
//     {'name': 'Day wise Agent Balance', 'code': 'dayWiseAgentBalance'},
//     {'name': 'Day Wise Opening Balance', 'code': 'dayWiseOpeningBalance'},
//     {'name': 'PNR Remarks', 'code': 'pnrRemarks'},
//     {'name': 'Offline PNR Report', 'code': 'offlinePnrReport'},
//     {'name': 'Flight Series', 'code': 'flightSeries'},
//     {'name': 'Credit / Debit Transaction', 'code': 'creditDebitTransaction'},
//     {'name': 'PNR Transaction History', 'code': 'pnrTransactionHistory'},
//     {'name': 'Consolidate Sales', 'code': 'consolidateSales'},
//     {'name': 'Customer Deposit Details', 'code': 'customerDepositDetails'},
//     {'name': 'Policy wise sales', 'code': 'policyWiseSales'},
//     {'name': 'Oustanding', 'code': 'oustading'},
//     {'name': 'Agent Invoice Details Report', 'code': 'agentInvoiceDetailsReport'},
//     {'name': 'Credit Debit Report', 'code': 'creditDebitReport'},
//     {'name': 'No Show Details', 'code': 'noShowDetails'},
//     {'name': 'Ticket Reconciliation', 'code': 'ticketReconciliation'},
//     {'name': 'Credit Info', 'code': 'creditInfo'},
//     {'name': 'Supplier Commission Details', 'code': 'supplierCommissionDetails'},
//     {'name': 'L2B Details', 'code': 'l2bDetails'},
//     {'name': 'Detailed Transaction', 'code': 'detailedTransaction'},
//     {'name': 'Cancel and Reschedule Request Detail', 'code': 'cancelAndRescheduleRequestDetail'},
//     {'name': 'Distributor Ledger', 'code': 'distributorLedger'},
//     {'name': 'Agent Details', 'code': 'agentDetails'},
//     {'name': 'Service Fee/Markup Details', 'code': 'serviceFeeMarkupDetails'},
//     {'name': 'Commission Details', 'code': 'commissionDetails'},
//     {'name': 'Invoice Detail', 'code': 'invoiceDetail'},
//     {'name': 'Fare Trend Details', 'code': 'fareTrendDetails'},
//     {'name': 'MIS Sales Analysis', 'code': 'misSalesAnalysis'}
// ]

//    'Action': [
//
//
//
//
//     {'name': 'Ticket To Cancel', 'code': 'ticketcancel'},
//     {'name': 'Ticket To Reschedule', 'code': 'ticketreschedule'},
//     {'name': 'Fare Rule', 'code': 'farerule'},
//     {'name': 'Visa', 'code': 'visa'},
//
//     {'name': 'Trip Travel Request', 'code': 'triptravelrequest'},
//     {'name': 'Insurance Plan View', 'code': 'insuranceplanview'},
//     {'name': 'Insurance Plan Mapping', 'code': 'insuranceplanmapping'},
//     {'name': 'ERP Status', 'code': 'erpstatus'},
//     {'name': 'Unpurge PNR', 'code': 'unpurgepnr'},
//     {'name': 'Airline DSR Upload', 'code': 'airlinedsrupload'},
//     {'name': 'Passenger Profile', 'code': 'passengerprofile'},
//     {'name': 'Push Notification', 'code': 'pushnotification'},
//     {'name': 'Admin Configuration', 'code': 'adminconfiguration'}
// ]

//    'Control Panel': [
//     { 'name': 'Advertisement', 'code': 'advertisement' },
//     { 'name': 'Airline Segments', 'code': 'airlineSegment' },
//     { 'name': 'Change Password', 'code': 'changepassword' },
//     { 'name': 'Corporate (B2E)', 'code': 'corporatelist' },
//     { 'name': 'Notice Board', 'code': 'noticeboard' },
//     { 'name': 'ROE Updation', 'code': 'roeupdation' },
//     { 'name': 'User Management (BOA)', 'code': 'usermanagement' },
//     { 'name': 'Supplier Management', 'code': 'suppliermanagement' },
//     { 'name': 'Agent (B2B)', 'code': 'agentb2b' },
//     { 'name': 'Customer (B2C)', 'code': 'customerb2c' },
//     { 'name': 'Currency ROE', 'code': 'currencyroe' },
//     { 'name': 'Corporate Management', 'code': 'corporatemanagement' },
//     { 'name': 'Pending Agent Request', 'code': 'pendingagentrequest' },
//     { 'name': 'Add GST', 'code': 'addgst' },
//     { 'name': 'Add Bank Details', 'code': 'addbankdetails' },
//     { 'name': 'Thread Mapping', 'code': 'threadmapping' },
//     { 'name': 'Ticket Points', 'code': 'ticketpoints' },
//     { 'name': 'IP/2FA', 'code': 'ip2fa' },
//     { 'name': 'Alert And Notification', 'code': 'alertandnotification' },
// ]
// }
